export default function getDefaultState () {
  return {
    clients: {},
    errors: null,
    showApiErrors: false,
    loadingProfileSetting: false,
    loadingProfileSettingSet: false
  }
}
